import React, { createContext } from 'react';

const AppsTranslationsContext = createContext();

export default AppsTranslationsContext;
